import { getWindow } from '@stitch-fix/mode-react';

const initMocks = async () => {
  const win = getWindow();

  if (win) {
    // require is synchronous, which allows MSW to be initialized before the app renders,
    // see: https://github.com/mswjs/msw/discussions/1236
    // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
    const { worker } = require('./browser');

    worker.start();
  } else {
    const { server } = await import('./server');

    server.listen();
  }
};

initMocks();
